import React from 'react'
import ReactDOM from 'react-dom/client'
import { isIE } from 'react-device-detect'
import './index.css'
import AppWrapper from './AppWrapper'

// Полифилл для process в браузере
if (typeof process === 'undefined') {
  window.process = {
    env: {
      NODE_ENV: 'development',
      REACT_APP_DOMAIN: 'shop.xsocks.pro',
      REACT_APP_API_DOMAIN: 'api.xsocks.pro',
      REACT_APP_NAME: 'XSocks',
      REACT_APP_EMAIL: 'support@xsocks.pro',
      REACT_APP_TG: 'xsocks_support'
    }
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'))

let content = null
if (isIE) {
  content = <div>Not supported.</div>
} else {
  content = (
    <AppWrapper />
  )
}

root.render(
  <React.StrictMode>
   {content}
  </React.StrictMode>
)
